import React, { useEffect, useState } from "react";
import Workspace from "./components/Workspace";
import { Edge, useEdgesState, useNodesState } from "@xyflow/react";
import DeviceViewer from "./components/DeviceViewer";
import TopBar from "./components/TopBar";
import { TrackersView } from "./components/TrackerViewer";
import Energia from "./components/Energia";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import config from "./config";
type ImagesByType = {
  [key: string]: string;
};

const App = () => {
  const [images, setImages] = useState<ImagesByType>({
    inversor: "",
    estacao: "",
    medidor: "",
    releProtecao: "",
    releTemperatura: "",
  });
  const [nodes, setNodes, onNodesChange] = useNodesState<any>([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState<Edge>([]);
  const [viewDevice, setViewDevice] = useState<any>(null);
  const [viewTrackers, setViewTrackers] = useState<any>(null);
  const [trackersData, setTrackersData] = useState<any>(null);
  const [comunicacaoNodes, setComunicacaoNodes, onComunicacaoNodesChange] =
    useNodesState<any>([]);
  const [comunicacaoEdges, setComunicacaoEdges, onComunicacaoEdgesChange] =
    useEdgesState<Edge>([]);
  const [isTopBarExpanded, setIsTopBarExpanded] = useState(true);
  const [activeTab, setActiveTab] = useState<string>("energia");
  const [loading, setLoading] = useState(false);
  const [tempoColeta, setTempoColeta] = useState({
    inversor: 30,
    meter: 30,
    meteo: 30,
    rele: 30,
    reletemp: 30,
    combiner: 30,
  });
  const [nomeUsina, setNomeUsina] = useState("");

  const getUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    const paramObj: { [key: string]: string } = {};
    params.forEach((value, key) => {
      paramObj[key] = value;
    });
    return paramObj;
  };

  const urlParams = getUrlParams();

  const getConfig = async () => {
    // Buscar do backend
    const url = config.plataforma
      ? `https://apiplataforma.pvoperation.com/v2/configscada?usina=${urlParams.usina}`
      : "https://apisupervisorio.pvoperation.com/get-config?fileName=energia.json";
    const headers: any = {
      "Content-Type": "application/json",
    };
    if (config.plataforma) {
      headers["X-Auth-Token-Update"] = urlParams.token;
    }
    fetch(url, {
      headers,
    })
      .then((response) => response.json())
      .then((data) => {
        setNodes(data.nodes || []);
        setEdges(data.edges || []);
        setTempoColeta(
          data.regras || {
            inversor: 30,
            meter: 30,
            meteo: 30,
            rele: 30,
            reletemp: 30,
            combiner: 30,
          }
        );
        setNomeUsina(data.nome || "");
        setTimeout(() => {
          setLoading(false);
        }, 400);
      })
      .catch((error) => console.error("Erro:", error));
    if (!config.plataforma) {
      fetch(
        `https://apisupervisorio.pvoperation.com/get-config?fileName=comunicacao.json`
      )
        .then((response) => response.json())
        .then((data) => {
          setComunicacaoNodes(data.nodes || []);
          setComunicacaoEdges(data.edges || []);
        })
        .catch((error) => console.error("Erro:", error));
    }
  };

  useEffect(() => {
    setLoading(true);
    getConfig();
  }, []);

  const loadConfig = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const text = await file.text();
      const config = JSON.parse(text);

      const activeSetNodes =
        activeTab === "energia" ? setNodes : setComunicacaoNodes;
      const activeSetEdges =
        activeTab === "energia" ? setEdges : setComunicacaoEdges;

      activeSetNodes(config.nodes);
      activeSetEdges(config.edges);

      const fileName =
        activeTab === "comunicacao" ? "comunicacao.json" : "energia.json";

      // Enviar para o backend
      fetch("https://apisupervisorio.pvoperation.com/save-config", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fileName, config }),
      })
        .then((response) => {
          if (response.ok) {
            toast.success("Arquivo salvo com sucesso!", {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          } else {
            toast.error("Ocorreu um erro ao salvar o arquivo, tente novamente mais tarde!", {
              position: "top-right",
              autoClose: 4000, // Fechar após 3 segundos
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
        })
        .catch((error) => console.error("Erro:", error));
    }
  };
  const CommandDj = () => {
    axios
      .post("https://apisupervisorio.pvoperation.com/command", {
        cmd: 1,
      })
      .then((response: any) => {
        if (response.data.success) {
          // Notificação de sucesso
          toast.success("Comando remoto realizado com sucesso!", {
            position: "top-right",
            autoClose: 4000, // Fechar após 3 segundos
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      })
      .catch((error) => {
        console.error("Erro ao enviar comando:", error);
        // Notificação de erro
        toast.error("Erro ao realizar o comando remoto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };
  return (
    <div className="flex flex-col w-full h-screen">
      {!config.plataforma ? (
        <TopBar
          onLoadConfig={loadConfig}
          onTabChange={(tab) => {
            setLoading(true);
            setTimeout(() => {
              setLoading(false);
            }, 100);
          }}
          isExpanded={isTopBarExpanded}
          onToggleExpand={() => setIsTopBarExpanded(!isTopBarExpanded)}
          activeTab={activeTab}
          onTabClick={(tab: string) => setActiveTab(tab)}
        />
      ) : null}
      {activeTab === "geracao" ? (
        <div>
          <Energia />
        </div>
      ) : (
        <div className="flex-grow overflow-hidden">
          {loading ? (
            <div className="flex items-center justify-center h-full">
              <div className="text-xl font-bold">Carregando...</div>
            </div>
          ) : (
            <Workspace
              nodes={activeTab === "energia" ? nodes : comunicacaoNodes}
              setNodes={activeTab === "energia" ? setNodes : setComunicacaoNodes}
              onNodesChange={
                activeTab === "energia"
                  ? onNodesChange
                  : onComunicacaoNodesChange
              }
              edges={activeTab === "energia" ? edges : comunicacaoEdges}
              setEdges={activeTab === "energia" ? setEdges : setComunicacaoEdges}
              onEdgesChange={
                activeTab === "energia"
                  ? onEdgesChange
                  : onComunicacaoEdgesChange
              }
              images={images}
              handleNodeClick={(_, node) => {
                const device = {
                  id: node.id,
                  name: node.data.label,
                  esn: node.data.esn,
                  type: node.data.type,
                  color: node.data.color,
                  position: node.position,
                  parent: node.parentId,
                  variaveis: node.data.variaveis,
                  leitura: node.data.last_state,
                  rulerVariables: node.data.rulerVariables,
                  eventos: node.data.eventos ? node.data.eventos : {},
                  atraso: node.data.atraso,
                };
                setViewDevice(device);
              }}
              setTrackersData={setTrackersData}
              tempoColeta={tempoColeta}
              usina={urlParams.usina}
              nomeUsina={nomeUsina}
            />
          )}
        </div>
      )}

      {/* Modais */}
      {viewDevice && (
        <DeviceViewer
          device={viewDevice}
          onCloseModal={() => setViewDevice(null)}
          CommandDj={() => CommandDj()}
        />
      )}

      {viewTrackers && (
        <TrackersView setViewTrackers={setViewTrackers} device={viewTrackers} />
      )}
      <ToastContainer />
    </div>
  );
};

export default App;
